import React from 'react';
import { node } from 'prop-types';
import { Button, SvgIcon } from '@mui/material';
import ArrowRightIcon from 'mdi-react/ArrowRightIcon';

const NextButton = ({ children, ...props }) => (
  <Button {...props}>
    {children}
    <SvgIcon sx={{ mt: '1px', ml: '5px', fontSize: 17 }}>
      <ArrowRightIcon />
    </SvgIcon>
  </Button>
);

NextButton.propTypes = {
  children: node.isRequired,
};

export default NextButton;
